import {XMarkIcon} from '@heroicons/react/24/outline'
import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import Dialog from './Dialog'
import FlatButton from './FlatButton'

type Props = Readonly<{
  open: boolean
  onClose: () => void
}>

function RegistrationWelcomePopup({open, onClose}: Props): JSX.Element {
  const intl = useIntl()
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="flex flex-col items-center gap-10">
        <div className="flex w-full items-center justify-between">
          <Dialog.Title className="typography-headline-5 text-center font-[700]">
            <FormattedMessage id="registration.welcome_title" />
          </Dialog.Title>
          <div>
            <FlatButton
              aria-label={intl.formatMessage({id: 'general.Close'})}
              icon={<XMarkIcon className="h-6 w-6" aria-hidden />}
              onClick={onClose}
              type="button"
              variant="transparent"
            />
          </div>
        </div>
        <div className="flex flex-col items-center">
          <p className="typography-headline-6">
            <FormattedMessage id="registration.welcome_new_title" />
          </p>
          <p className="typography-body-1 mt-2 max-w-prose whitespace-pre-wrap text-center">
            <FormattedMessage id="registration.welcome_new_body" />
          </p>
          <p className="typography-headline-6 mt-8">
            <FormattedMessage id="registration.welcome_existing_title" />
          </p>
          <p className="typography-body-1 mt-2 max-w-prose whitespace-pre-wrap text-center">
            <FormattedMessage
              id="registration.welcome_existing_body"
              values={{
                a: parts => (
                  <Link className="text-teal-secondary underline" to="/login">
                    {parts}
                  </Link>
                )
              }}
            />
          </p>
        </div>
        <FlatButton type="button" variant="success" onClick={onClose}>
          <FormattedMessage id="registration.welcome_action" />
        </FlatButton>
      </div>
    </Dialog>
  )
}

export default RegistrationWelcomePopup
